<template>
  <div class="flex flex-col gap-6">
    <component
      v-for="panel in checkDataPanels"
      :key="panel.id"
      :is="panel.component"
      :title="panel.title"
      :description="panel.description"
      :button-label="$t('widgets.actions.check_data')"
      :panel-type="panel.type"
      :selected-resort-uuid="selectedResortUuid"
      :resort-info="resortInfo"
    />
  </div>
</template>

<script>
import CheckWeatherPanel from '@/modules/Apps/Pages/widgets/components/CheckWeatherPanel.vue'
import CheckFacilitiesDifficultyPanel from '@/modules/Apps/Pages/widgets/components/CheckFacilitiesDifficultyPanel.vue'
import CheckLiftsByTypePanel from '@/modules/Apps/Pages/widgets/components/CheckLiftsByTypePanel.vue'
import CheckSimpleTotalsPanel from '@/modules/Apps/Pages/widgets/components/CheckSimpleTotalsPanel.vue'

export default {
  name: 'CheckDataPanels',
  components: {
    CheckWeatherPanel,
    CheckFacilitiesDifficultyPanel,
    CheckLiftsByTypePanel,
    CheckSimpleTotalsPanel
  },
  props: {
    selectedResortUuid: {
      type: String,
      required: true
    },
    resortInfo: {
      type: Object,
      default: null
    }
  },
  computed: {
    checkDataPanels() {
      return [
        {
          id: 'slope',
          type: 'slope',
          component: 'CheckFacilitiesDifficultyPanel',
          title: this.$t('widgets.sections.slopes.title'),
          description: this.$t('widgets.sections.slopes.description')
        },
        {
          id: 'lift',
          type: 'lift',
          component: 'CheckLiftsByTypePanel',
          title: this.$t('widgets.sections.lifts.title'),
          description: this.$t('widgets.sections.lifts.description')
        },
        {
          id: 'bikepark-trail',
          type: 'bikepark-trail',
          component: 'CheckFacilitiesDifficultyPanel',
          title: this.$t('widgets.sections.bikepark.title'),
          description: this.$t('widgets.sections.bikepark.description')
        },
        {
          id: 'link',
          type: 'link',
          component: 'CheckSimpleTotalsPanel',
          title: this.$t('widgets.sections.links.title'),
          description: this.$t('widgets.sections.links.description')
        },
        {
          id: 'parking',
          type: 'parking',
          component: 'CheckSimpleTotalsPanel',
          title: this.$t('widgets.sections.parking.title'),
          description: this.$t('widgets.sections.parking.description')
        },
        {
          id: 'road',
          type: 'road',
          component: 'CheckSimpleTotalsPanel',
          title: this.$t('widgets.sections.access.title'),
          description: this.$t('widgets.sections.access.description')
        },
        {
          id: 'weather',
          type: 'weather',
          component: 'CheckWeatherPanel',
          title: this.$t('widgets.sections.weather.title'),
          description: this.$t('widgets.sections.weather.description')
        }
      ]
    }
  }
}
</script>
